import React, { ReactNode } from 'react';
import UIStrings from '@/Utils/UIStrings';
import BodyTypography from '../../../../Common/BodyTypography';
import GridRowNode from '../Common/GridRowNode';

export interface QualificationItemProps {
    period: string;
    header1: string;
    header2: string;
    label: string;
    badge?: ReactNode;
}

export function QualificationItem({
    period,
    header1,
    header2,
    label,
    badge,
}: QualificationItemProps): React.JSX.Element {
    return (
        <GridRowNode
            title={<BodyTypography>{period}</BodyTypography>}
            node={
                <div className="flex flex-col gap-1">
                    <BodyTypography>
                        <span className="font-bold">{header1}</span>
                        <span className="font-normal">{` ${UIStrings.At} `}</span>
                        <span className="font-bold">{header2}</span>
                    </BodyTypography>
                    <BodyTypography>{label}</BodyTypography>
                    {badge && badge}
                </div>
            }
        />
    );
}
